
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Nach Angaben von WHO-Chef Tedros Adhanom Ghebreyesus sind für den Kampf gegen das Coronavirus Sars-CoV-2 jetzt 20 Impfstoffe in Entwicklung. Bei der WHO seien zudem Anträge auf Prüfung und Zulassung von 40 Tests eingegangen.`}</p>
    <p>{`Mitte Februar einigten sich 400 Experten auf einer Konferenz in Genf, die Suche nach einem Impfstoff zu beschleunigen. In vielen Ländern wird derzeit an der Entwicklung eines Impfstoffes gearbeitet. Doch wie schnell könnte er einsatzbereit sein? `}<strong parentName="p">{`«Ich bin insgesamt sehr sicher, dass wir erste experimentelle Impfstoffe noch dieses Jahr sehen werden»`}</strong>{`, sagt der Virologe Gerd Sutter von der Ludwig-Maximilians-Universität München. Ob und wann sie an Menschen getestet werden könnten, sei eine andere Sache. «Die Entwicklung eines Impfstoffs ist ein langwieriger, mühsamer Prozess, vor allem die Zulassung und die klinische Prüfung eines Kandidaten.»`}</p>
    <p>{`Optimistisch zeigt sich der Epidemiologe Salathé: `}<strong parentName="p">{`«Mich würde es erstaunen, wenn man nicht bis Ende Jahr einen Impfstoff hätte.`}</strong>{` Dann wäre nächstes Jahr die Situation ­wieder normal. In den nächsten Monaten müssen wir das Coronavirus aber mit nichtpharmazeutischen Massnahmen managen.»`}</p>
    <p>{`LESEN SIE AUCH`}<br /><Link disco href='https://www.tagesanzeiger.ch/wissen/impfstoffforscher-in-basel-wir-sind-mit-der-entwicklung-sehr-weit/story/15981874' icon='icon bookmark outline' allowWordWrap mdxType="Link">{`Impfstoff-Forscher in Basel: «Wir sind mit der Entwicklung sehr weit»`}</Link></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;